{
  "brandTitle": "VBB PLAY — Дастгирии зинда",
  "brandShort": "VBB PLAY Дастгирӣ",
  "liveLabel": "VBB PLAY Дастгирии зинда",
  "online": "Онлайн",
  "offline": "Офлайн",
  "close": "Пӯшидан",
  "moreOptions": "Иловагӣ",
  "closeChat": "Чат пӯшидан",
  "closeMenu": "Менюро пӯшидан",
  "operator": "Оператори VBB PLAY",
  "removeFile": "Файлро нест кардан",
  "attachFile": "Файл илова кардан",
  "loadFailed": "Бор нашуд.",
  "fileTooLarge": "Файл аз 50 МБ калонтар аст.",
  "sendFailed": "Паём фиристода нашуд ({{status}})",
  "networkError": "Хатои шабака. Дубора кӯшиш кунед.",
  "nameRequired": "Номатонро ворид кунед.",
  "emailInvalid": "Почтаи дуруст нависед.",
  "topicRequired": "Мавзӯъро интихоб кунед.",
  "messageRequired": "Мушкилотро мухтасар нависед.",
  "consentRequired": "Розигии махфият лозим аст.",
  "requestFailed": "Дархост фиристода нашуд.",
  "messagePlaceholder": "Тавсифи мухтасар…",
  "sending": "Фиристода мешавад…",
  "startLive": "Дастгирии зиндаро оғоз кардан",
  "ratingFailed": "Баҳо фиристода нашуд.",
  "ratingPlaceholder": "Шарҳи кӯтоҳ (ихтиёрӣ)",
  "contactSaveFailed": "Маълумоти тамос нигоҳ дошта нашуд.",
  "save": "Нигоҳ доштан",
  "loginRequired": "Барои навиштан ба дастгирии зинда ворид шавед.",
  "intakeHint": "Барои кӯмаки тезтар маълумотатонро ворид кунед.",
  "back": "Бозгашт",
  "yourName": "Номи шумо",
  "yourEmail": "Почтаи электронии шумо",
  "emailPlaceholder": "email@намуна.com",
  "topicLabel": "Мавзӯъ",
  "topicSelect": "Интихоб кунед…",
  "messageLabel": "Мушкилот ё паём",
  "consentLong": "Ба коркарди маълумоти шахсӣ розӣ ҳастам. Бо Сиёсати махфият шинос шудам.",
  "soundOff": "🔊 Хомӯш кардани овоз",
  "soundOn": "🔇 Фаъол кардани овоз",
  "rateOperator": "⭐ Баҳо додан ба оператор",
  "editContact": "✎ Тағйири маълумоти шахсӣ",
  "searchingOperator": "🔎 Оператор ҷустуҷӯ мешавад...",
  "waitingOperator": "⏳ Дархост қабул шуд. Операторо интизор шавед.",
  "operatorJoined": "Оператор {{name}} ба чат пайваст шуд",
  "sendFailedShort": "Фиристода нашуд",
  "retry": "Дубора кӯшиш",
  "cameraShot": "📷 Акс бо камера",
  "pickPhoto": "🖼️ Интихоби акс",
  "pickVideo": "🎬 Интихоби видео",
  "pickFile": "📁 Интихоби файл ё ҳуҷҷат",
  "textPlaceholder": "Матн...",
  "messageAria": "Паём",
  "sendAria": "Фиристодан",
  "emojiAria": "Эмоҷи",
  "rateTitle": "Баҳо додан ба оператор",
  "submitRate": "Фиристодан",
  "editContactTitle": "Тағйири маълумоти шахсӣ",
  "cameraPermissionTitle": "Иҷозати камера",
  "cameraPermissionBody": "Барои аксгирӣ дастрасӣ ба камера лозим аст. Равзанаи браузер метавонад дар забони дастгоҳ бимонад.",
  "allowCamera": "Иҷозат додан",
  "notNow": "Ҳоло не",
  "namePlaceholder": "Ном",
  "topic_deposit": "Мушкили амонат",
  "topic_withdraw": "Мушкили гирифтан",
  "topic_balance": "Мушкили тавозун",
  "topic_game": "Мушкили бозӣ",
  "topic_bonus": "Мушкили бонус",
  "topic_account": "Ҳисоб / вуруд",
  "topic_tech": "Мушкили техникӣ",
  "topic_other": "Саволи дигар",
  "fileOpenFailed": "Файл кушода нашуд: {{name}}",
  "retryShort": "Дубора",
  "fileLoading": "Боркунии файл: {{name}}",
  "emoji_smileys": "Чеҳраҳо",
  "emoji_people": "Ишораҳо",
  "emoji_nature": "Табиат",
  "emoji_food": "Хӯрок",
  "emoji_activity": "Варзиш",
  "emoji_travel": "Сафар",
  "emoji_objects": "Ашё",
  "emoji_symbols": "Аломатҳо",
  "emoji_flags": "Парчамҳо"
}
